
/**
 * Module dependencies.
 */

import { useTranslation as useI18nTranslation } from 'react-i18next';

/**
 * `TranslateProps` type.
 */

type TranslateProps = {
  i18n: any;
  translate: (key: Array<string> | string, interpolation?: any) => string;
};

/**
 * Export `useTranslate`.
 */

export function useTranslate(namespaces?: Array<string> | string, options?: any): TranslateProps {
  const { t: translate, ...rest } = useI18nTranslation(namespaces, options);

  return {
    ...rest,
    translate
  };
}
